import { render, staticRenderFns } from "./ModalSignatureTopaz.vue?vue&type=template&id=0b20f649&"
import script from "./ModalSignatureTopaz.vue?vue&type=script&lang=js&"
export * from "./ModalSignatureTopaz.vue?vue&type=script&lang=js&"
import style0 from "./ModalSignatureTopaz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports